define('lib',['jquery', 'underscore'], function ($, _) {
    'use strict';

    var $selectors = {};
    return {
        lpad: function(num, len, padstr) {
            var str = ''+num;
            if(str.length >= len) { return str; }
            return (new Array(len + 1 - str.length)).join(padstr) + str;
        },
        pluralTime: function(number, unit) {
            var plural = 'er';
            if (unit.charAt(unit.length-1) === 'e') {
                plural = 'r';
            }
            if (number > 1) {
                return number + ' ' + unit + plural;
            } else {
                return number + ' ' + unit;
            }
        },
        getDateTime: function(time) {
            var date = new Date();
            date.setTime(time*1000);
            return date.getFullYear()+'-'+this.lpad(date.getMonth()+1,2,0)+'-'+this.lpad(date.getDate(),2,0)+'T'+this.lpad(date.getHours(),2,0,0)+':'+this.lpad(date.getMinutes(),2,0);
        },
        getDate: function(time) {
            var date = new Date();
            date.setTime(time*1000);
            //this.lpad(date.getHours(),2,0,0)+':'+this.lpad(date.getMinutes(),2,0)+' - '
            return this.lpad(date.getDate(),2,0)+'.'+this.lpad(date.getMonth()+1,2,0)+'.'+date.getFullYear();
        },
        getTimeSinceTimestamp: function(time, overrides) {
            if (!time) {
                return '';
            }

            var options = {
                postfix: ' siden',
                labels: {
                    now: {
                        text: 'Nå',
                    },
                    day: {
                        text: 'dag',
                        plural: true,
                    },
                    hour: {
                        text: 'time',
                        plural: true,
                    },
                    min: {
                        text: 'minutt',
                        plural: true,
                    },
                }
            };

            if (overrides) {
                options = Object.assign({}, options, overrides);
            }

            var getLabel = _.bind(function(value, type) {
                var label = options.labels[type];
                if (!!label) {
                    return (
                        label.plural ? this.pluralTime(value, label.text) : value + ' ' + label.text
                    ) + options.postfix;
                }

                return '';
            }, this);

            var timeDate = new Date(time);
            var now = new Date();
            var diff = Math.ceil((now.getTime()/1000) - timeDate.getTime()/1000);

            if (diff < 60) {
                return 'Nå';
            } else if (diff < 3600) {
                var minutes = Math.floor(diff/60);
                return getLabel(minutes, 'min');
            } else if (diff < 86400) {
                var hours = Math.floor(diff/3600);
                return getLabel(hours, 'hour');
            } else {
                var days = Math.floor(diff/86400);
                if (days <= 3) {
                    return getLabel(days, 'day');
                } else {
                    return this.getDate(time);
                }
            }
        },
        getTimeSince: function(time) {
            if (!time) {
                return '';
            }

            time = time.toString().substring(0, 10);
            var now = new Date();
            var diff = Math.ceil((now.getTime()/1000) - time);
            if (diff < 60) {
                return 'Nå';
            } else if (diff < 3600) {
                var minutes = Math.floor(diff/60);
                return this.pluralTime(minutes, 'minutt') + ' siden';
            } else if (diff < 86400) {
                var hours = Math.floor(diff/3600);
                return this.pluralTime(hours, 'time') + ' siden';
            } else {
                var days = Math.floor(diff/86400);
                if (days <= 3) {
                    return this.pluralTime(days, 'dag') + ' siden';
                } else {
                    return this.getDate(time);
                }
            }
        },
        getSessionId: function() {
            if (!this.sessionId) {
                var sessionId = (Math.random()+1).toString(30).substring(2, 20);
                if (this.hasLocalStorage()) {
                    var localStorageSessionId = localStorage.getItem('sessionId');
                    if (localStorageSessionId) {
                        sessionId = localStorageSessionId;
                    } else {
                        localStorage.setItem('sessionId', sessionId);
                    }
                }
                this.sessionId = sessionId;
            }
            return this.sessionId;
        },
        chunks: function(array, n) {
            return _.compact(_.map(array, function(el, i){
                if (i % n === 0) {
                    return array.slice(i, i + n);
                }
            }));
        },
        attributeToBool: function(val) {
            if (!val) {
                return false;
            }
            if (val === '0' || val === 'false') {
                return false;
            }

            return true;
        },
        shuffle: function(o) {
            /* jshint ignore:start */
            for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
            /* jshint ignore:end */
            return o;
        },
        /*
        stripHtml: function(html) {
           var tmp = document.createElement('div');
           tmp.innerHTML = html;
           return tmp.textContent || tmp.innerText || '';
        },
        */
        getBasePath: function(url) {
            if (!this.basePath) {
                var htmlTag  = document.getElementsByTagName('html');
                this.basePath = htmlTag.length ? htmlTag[0].getAttribute('base') : '';
            }
            return this.basePath.concat(url || '');
        },
        getOMSBaseUrl: function() {
            if (!this.omsUrl) {
                var stage = 'bors-demo.e24.no';
                var prod = 'bors.e24.no';

                var host = (this.$('#app-data').data('stage') === 'production') ? prod : stage
                this.omsUrl = 'https://' + host + '/server';
            }
            return this.omsUrl;
        },
        getOMSSecureUrl: function() {
            this.omsUrlSecure = this.getOMSBaseUrl() + '/secure';
            return this.omsUrlSecure;
        },
        buildAuthUrl: function() {
            return this.getOMSBaseUrl() + '/login/spid';
        },
        buildMyStocksUrl: function(sessionId, ticker) {
            var base = this.getOMSSecureUrl() + '/watchlists/' + sessionId + '/E24_WATCHLIST';

            if (typeof ticker === 'undefined') {
                return base;
            }

            return base + '/' + encodeURIComponent(encodeURIComponent(ticker));
        },
        getApiUrl: function(url) {
            if (!this.apiUrl) {
                this.apiUrl = this.$('#app-data').data('apiUrl');
                if (!this.apiUrl) {
                    this.apiUrl = '//e24.no/api';
                }
            }
            return this.apiUrl.concat(url || '');
        },
        getCMHost: function() {
            if (!this.cmHost) {
                this.cmHost = this.$('#app-data').data('cmHost');
                if (!this.cmHost) return 'e24.no';
            }
            return this.cmHost;
        },
        getAbsRoute: function() {
            if (!this.absRoute) {
                var htmlTag  = document.getElementsByTagName('html');
                this.absRoute = (htmlTag.length ? htmlTag[0].getAttribute('route') : null) || 'unknown';
            }
            return this.absRoute;
        },
        getRoute: function() {
            if (!this.route) {
                var route = this.getAbsRoute();
                route = route.split('-');
                route = route[route.length-1];
                this.route = route;
            }
            return this.route;
        },
        getArticleId: function() {
            if (!this.articleId) {
                this.articleId = $('#article[data-id]').data('id');
            }

            return this.articleId;
        },
        getArticleType: function() {
            if (!this.articleType) {
                this.articleType = $('#article[data-articletype]').data('articletype');
            }

            return this.articleType;
        },
        /*
        getSectionId: function() {
            if (!this.sectionId) {
                this.sectionId = $('#article[data-section-id]').data('section-id');
            }

            return this.sectionId;
        },
        getArticleTitle: function() {
            if (!this.articleTitle) {
                this.articleTitle = $('.main-title').text();
            }

            return this.articleTitle;
        },
        */
        getShareUrl: function() {
            /**
             * Since Facebook doesn't support url migration, we have to
             * keep http in the shared urls. This function builds the
             * http version of the current url.
             */
            var hostname = encodeURIComponent(window.location.hostname);
            var pathname = encodeURIComponent(window.location.pathname);

            return 'http://' + hostname + pathname;
        },
        $document: function() {
            if (!this.$lazyDocument) {
                this.$lazyDocument = $(document);
            }

            return this.$lazyDocument;
        },
        $window: function() {
            if (!this.$lazyWindow) {
                this.$lazyWindow = $(window);
            }

            return this.$lazyWindow;
        },
        $html: function() {
            if (!this.$lazyHtml) {
                this.$lazyHtml = $(document.documentElement);
            }

            return this.$lazyHtml;
        },
        $body: function() {
            if (!this.$lazyBody) {
                this.$lazyBody = $(document.body);
            }

            return this.$lazyBody;
        },
        $: function(selector) {
            if (!$selectors[selector]) {
                $selectors[selector] = $(selector);
            }

            return $selectors[selector];
        },
        raf: function(cb) {
            var tick = window.requestAnimationFrame ||
                  window.webkitRequestAnimationFrame ||
                  window.mozRequestAnimationFrame ||
                  window.msRequestAnimationFrame ||
                  function(cb) {
                      setTimeout(cb, 1000 / 60);
                  };

            return tick(cb);
        },
        /*
        getBody: function () {
            if (!this.body) {
                this.body = $('body');
            }
            return this.body;
        },
        collide: function(el1, el2) {
            if(!el1.offset() || !el2.offset()) {
                return false;
            }

            // jshint expr: true
            return ( (el1.offset().top <= el2.offset().top && (el1.offset().top + el1.height()) >= el2.offset().top) ||
             (el2.offset().top <= el1.offset().top && (el2.offset().top + el2.height()) >= el1.offset().top) );
        },
        */
        on: function(el, ev, callback) {
            if (el.addEventListener) {
                return el.addEventListener(ev, callback, false);
            }
            else {
                return el.attachEvent('on'+ ev, callback);
            }
        },
        delegate: function(element, eventString, delegateSelector, callback) {
            return this.on(element, eventString, function(event) {
                var el;
                var target = $(event.target);

                if (target.is(delegateSelector)) {
                    el = target;
                } else {
                    el = target.closest(delegateSelector);
                }

                if (el.length) {
                    event.delegateTarget = el.get(0);
                    callback(event);
                }
            });
        },
        loadImage: function(src, cb) {
            var img = new Image();
            img.onload = img.onerror = function() {
                img.onload = img.error = null;
                img = null;

                if (cb) {
                    cb.call();
                }
            };
            img.src = src;
        },
        /*
        onElement: function(selector, found, notFound) {
            var el = $(selector);
            if (el.length) {
                found(el);
            }
            else {
                if (document.readyState !== 'complete') {
                    setTimeout(_.bind(function() {
                        this.onElement.call(this, selector, found, notFound);
                    }, this), 50);
                } else {
                    if (typeof(this.notFound) === 'function') {
                        this.notFound.call(this);
                    }
                }
            }
        },
        */
        checkAdsLoaded: function() {
            return $('.ad iframe[src^="/"]').filter(function() {
                return true; //!this.contentWindow.documentLoaded;
            }).length;
        },
        runWhenAdsAreLoaded: function(callback) {
            if (this.checkAdsLoaded() > 0 && callback) {
                _.delay(_.bind(function() {this.runWhenAdsAreLoaded(callback);},this), 400);
                return;
            }

            if(callback) {
                callback();
            }
        },
        hasLocalStorage: function() {
            if (this.localStorageSupported === undefined) {
                this.localStorageSupported = (function() {
                    try {
                        window.localStorage.setItem('storageSupported', 1);
                        window.localStorage.removeItem('storageSupported');

                        return (typeof(window.localStorage) !== 'undefined');
                    } catch (err) {
                        return false;
                    }
                })();
            }

            return this.localStorageSupported;
        },
        getUserId: function() {
            if (this.userId === undefined) {
                var userId = null;
                if (this.hasLocalStorage()) {
                    userId = window.localStorage.getItem('userId') || null;
                }
                this.userId = userId;
            }
            return this.userId;
        },
        getSubscriptionName: function() {
            if (this.subscriptionName === undefined) {
                var subscriptionName = null;
                if (this.hasLocalStorage()) {
                    subscriptionName = window.localStorage.getItem('subscriptionName') || null;
                }
                this.subscriptionName = subscriptionName;
            }
            return this.subscriptionName;
        },
        /*
        urlFriendly: function(url) {
            return url.trim().toLowerCase().replace(/æ/g,'ae').replace(/ø/g,'oe').replace(/å/g,'aa').replace(/[^a-zA-Z0-9]+/g, '-');
        },
        */
        isIE: function () {
            if (this.ie === undefined) {
                var myNav = navigator.userAgent.toLowerCase();
                this.ie = (myNav.indexOf('msie') !== -1) ? parseInt(myNav.split('msie')[1]) : false;
            }
            return this.ie;
        },
        isApp: function() {
            if (!this.app) {
                this.app = (String.prototype.indexOf && window.navigator && navigator.userAgent && navigator.userAgent.indexOf('E24-App') !== -1);
            }
            return this.app;
        },
        isVGApp: function() {
            if (!this.vgapp) {
                this.vgapp = (String.prototype.indexOf && window.navigator && navigator.userAgent && navigator.userAgent.indexOf('VG-App') !== -1);
            }
            return this.vgapp;
        },
        isMobile: function() {
            if (!this.mobile) {
                this.mobile = $('html').hasClass('mobile');
            }
            return this.mobile;
        },
        isTablet: function() {
            if (!this.tablet) {
                this.tablet = $('html').hasClass('tablet');
            }
            return this.tablet;
        },
        isDesktop: function() {
            if (!this.desktop) {
                this.desktop = $('html').hasClass('desktop') || $('html').hasClass('tablet');
            }
            return this.desktop;
        },
        /*
        isFacebook: function() {
            if (!this.facebook) {
                this.facebook = $('html').hasClass('facebook');
            }
            return this.facebook;
        },
        */
        getDevice: function() {
            if (!this.device) {
                this.device = (this.isMobile() ? 'mobile' : (this.isTablet() ? 'tablet' : 'desktop'));
            }
            return this.device;
        },
        getStage: function() {
            if (!this.stage) {
                this.stage = this.$('#app-data').data('stage');
                if (!this.stage) {
                    this.stage = '//e24.no/api';
                }
            }
            return this.stage;
        },
        isPreview: function() {
            if (this.preview === undefined) {
                this.preview = this.getStage() === 'preview';
            }
            return this.preview;
        },
        isProduction: function() {
            if (this.production === undefined) {
                this.production = this.getStage() === 'production';
            }
            return this.production;
        },
        isStaging: function() {
            if (this.staging === undefined) {
                this.staging = this.getStage() === 'staging';
            }
            return this.staging;
        },
        isFeature: function() {
            if (this.feature === undefined) {
                this.feature = this.getStage() === 'feature';
            }
            return this.feature;
        },
    };
});

